import React, { useState } from "react";
import api from "../api";
import "./auth.css";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await api.post("/login", { email, password });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("isAdmin", res.data.isAdmin);
      if (res.data.email) {
        localStorage.setItem("userEmail", res.data.email);
      }


      // Check if this is the admin email
      if (res.data.isAdmin) {
        navigate("/admin/client-report");
      } else {
        navigate("/profile");
      }

    } catch (err) {
      alert("Invalid credentials");
    }
  };


const handleGoogleLogin = async (credentialResponse) => {
  try {
    const res = await api.post("/google-login", {
      token: credentialResponse.credential,
    });

    const { token, isNewUser, isAdmin, email: googleEmail } = res.data;

    // Save to localStorage
    localStorage.setItem("token", token);
    localStorage.setItem("isAdmin", isAdmin.toString()); // store as string
    if (googleEmail) {
      localStorage.setItem("userEmail", googleEmail);
    }

    console.log("admin:", isAdmin);

    if (isAdmin) {
  // ✅ double-check with backend before navigating
  await api.get("/is-admin", {
    headers: { Authorization: `Bearer ${token}` },
  });
  navigate("/admin/client-report");
} else if (isNewUser) {
  navigate("/register");
} else {
  navigate("/profile");
}


  } catch (err) {
    console.error("Google login failed", err.response?.data);
    alert("Google Login Failed");
  }
};

  return (
    <div className="auth-container">
        <div className="auth-form">
      <h1>Login</h1>
      <input className="auth-form input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
      <br />
      <input className="auth-form input" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" type="password" />
      <br />
      <button onClick={handleLogin}>Login</button>
      <br />
      <GoogleLogin onSuccess={handleGoogleLogin} onError={() => alert("Google Sign-In Error")} />
      <br />
      <div style={{ marginTop: "16px", textAlign: "center" }}>
      <a href="/">Don't have an account? Sign up</a>
      </div>
      </div>
    </div>
  );
}

export default Login;
